import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
} from '@mui/material';

const ProductPriceModal = ({ open, handleClose, handleSave, initialData }) => {
  const [productRate, setProductRate] = useState({});

  useEffect(() => {
    if (open) {
      setProductRate(initialData || {});
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numValue = value === '' ? '' : Math.max(0, parseFloat(value) || 0);
    setProductRate({
      ...productRate,
      [name]: numValue,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleanedData = {};
    Object.entries(productRate).forEach(([key, value]) => {
      cleanedData[key] = value === '' ? 0 : value;
    });
    handleSave(cleanedData);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: 520 },
          maxHeight: '85vh',
          overflowY: 'auto',
          bgcolor: '#141821', 
          color: '#e0e0e0',
          boxShadow: '0 0 30px rgba(0,0,0,0.8)',
          p: 4,
          borderRadius: '8px',
          border: '1px solid #2c303a', 
          '& .MuiTypography-root': {
            color: '#ffffff',
          },
          '& .MuiInputLabel-root': {
            color: '#b0b8c4',
            '&.Mui-focused': {
              color: '#8be9fd',
            },
          },
          '& .MuiOutlinedInput-root': {
            color: '#ffffff',
            '& fieldset': {
              borderColor: '#343a46',
            },
            '&:hover fieldset': {
              borderColor: '#4c566a',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#6272a4',
              borderWidth: '2px',
            },
            '& input': {
              '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
                opacity: 0.6,
              },
            },
          },
          '& .MuiButton-contained': {
            bgcolor: '#6272a4',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              bgcolor: '#7a88b8',
            },
          },
          '& .MuiButton-outlined': {
            borderColor: '#343a46',
            color: '#b0b8c4',
            textTransform: 'none',
            '&:hover': {
              borderColor: '#6272a4',
              bgcolor: 'rgba(98, 114, 164, 0.15)',
            },
          },
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Update Product Prices
        </Typography>
        <form onSubmit={handleSubmit}>
          {Object.entries(productRate).length > 0 ? (
            Object.entries(productRate).map(([product, price]) => (
              <TextField
                key={product}
                label={product.replace(/_/g, ' ')}
                type="number"
                name={product}
                value={productRate[product] ?? ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                inputProps={{
                  step: '0.01',
                  min: '0',
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            ))
          ) : (
            <Typography variant="body2" color="#8be9fd" sx={{ mb: 2 }}>
              No products configured
            </Typography>
          )}
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 3 }}>
            Save Changes
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
            fullWidth
            sx={{ mt: 1.5 }}
          >
            Cancel
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default ProductPriceModal;